import { render, staticRenderFns } from "./CreatePlusTemplateList.vue?vue&type=template&id=06d825b7&scoped=true&"
import script from "./CreatePlusTemplateList.vue?vue&type=script&lang=js&"
export * from "./CreatePlusTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlusTemplateList.vue?vue&type=style&index=0&id=06d825b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d825b7",
  null
  
)

export default component.exports